module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": !_vm.isLoading,
      "size": 100,
      "height": true
    }
  }, [(_vm.isMessage) ? _c('SuccessMessage', {
    attrs: {
      "isError": _vm.isError,
      "errorMessage": _vm.errorMessage
    },
    on: {
      "understood": function($event) {
        return _vm.$emit('understood')
      }
    }
  }) : _c('RequestForm', {
    on: {
      "submitVacancyForm": _vm.submitRespond,
      "cancelRequest": _vm.cancelRespond
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d669b65e","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vacancies/form/VacancyRespondForm.vue
// module id = a32e9e8600f58afeb788
// module chunks = 13